module.exports = __webpack_public_path__ + "static/media/hydration.cbbf837a.svg";